module.exports = __webpack_public_path__ + "static/group-bg-3-a0985dcce4455a2fd24901ac67eee206.jpeg";